module.exports = __webpack_public_path__ + "img/02_2_2_1.5170a837.png";